export default __webpack_public_path__ + "static/2-4ed799b05543290de166e748efb2ba23.jpg";